/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 10/22/18
 * Copyright All Rights Reserved
 */

import { keyBy } from 'lodash/fp';
import React from 'react';

const tips = [
  {
    id: 'newPassword',
    header: 'Password Requirements',
    body: (
      <ul>
        <li>At least 8 characters</li>
        <li>At least 1 lowercase alphabetical character</li>
        <li>
          At least 1 of the following special characters: = + - ^ $ * [ ] { } ( ) ? ! @ # & % | _ ~
        </li>
      </ul>
    ),
  },
  {
    id: 'confirmationCode',
    header: 'Confirmation Code',
    body: 'This is the code we sent to your email address',
  },
];

const tooltipsById = (state = keyBy('id', tips)) => state;

export default tooltipsById;



// WEBPACK FOOTER //
// ./js/reducers/ui/tooltips/index.jsx